import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, FormEventHandler, PropsWithChildren, ReactNode } from "react";
import { CalculatorPageLayout } from "web_myplann/Calculators/Components/CalculatorPageLayout";
import { CalculatorResultSkeleton } from "web_myplann/Calculators/Components/CalculatorResultSkeleton";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	type: CalculatorType;
	onSubmit: FormEventHandler<HTMLFormElement>;
	notice?: ReactNode;
	fields: ReactNode;
	result?: ReactNode;
	isResultLoading?: boolean;
};

export const CalculatorShell: FC<PropsWithChildren<Props>> = ({
	type,
	onSubmit,
	notice,
	fields,
	result,
	isResultLoading = false,
	children,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const resultContent = isResultLoading ? <CalculatorResultSkeleton /> : result;

	return (
		<CalculatorPageLayout type={type} disableBottomBarSpacing={!!resultContent}>
			<Stack component="form" onSubmit={onSubmit} minHeight="100%" noValidate>
				<Typography
					variant="body2"
					px={theme.spacingTokens.lg}
					pt={theme.spacingTokens.md}
					display="block"
				>
					{t(Resources.Calculators.Intros[type])}
				</Typography>
				{notice}
				<Stack
					bgcolor={theme.palette.background.paper}
					mt={theme.spacingTokens.md}
				>
					{fields}
				</Stack>
				{resultContent && (
					<Stack flex={1} justifyContent="flex-end">
						{resultContent}
					</Stack>
				)}
				{children}
			</Stack>
		</CalculatorPageLayout>
	);
};
